import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    assignData: [],
    leadClassification: [],
    addLeadData: [],
    completedData: [],
    droppedData: [],
    leadManagement: [],
    leadSLA: [],
    dashBoardData: [],
    leadRecentData: [],
}

const mutations = {
    SET_ASSIGN_DATA(state, data) {
        state.assignData = data;
    },
    ADD_LEAD_TO_OTHER_ADMIN(state, data) {
        state.assignData.adminToLevels.push(data);
    },
    DELETE_LEAD_TO_OTHER_ADMIN(state, data) {
        var index = state.assignData.adminToLevels.findIndex(e => e.id == data);
        if (index != -1) {
            state.assignData.adminToLevels.splice(index, 1)
        }
    },
    ADD_UNASSIGNED_LEAD_TO_OTHER_ADMIN(state, data) {
        state.assignData.adminToUnassignedLevels.push(data);
    },
    DELETE_UNASSIGNED_LEAD_TO_OTHER_ADMIN(state, data) {
        var index = state.assignData.adminToUnassignedLevels.findIndex(e => e.id == data);
        if (index != -1) {
            state.assignData.adminToUnassignedLevels.splice(index, 1)
        }
    },
    ADD_ASSIGNED_ALL_LEAD_TO_OTHER_ADMIN(state, data) {
        state.assignData.adminToassignedAllLevels.push(data);
    },
    DELETE_ALL_ASSIGNED_LEAD_TO_OTHER_ADMIN(state, data) {
        var index = state.assignData.adminToassignedAllLevels.findIndex(e => e.id == data);
        if (index != -1) {
            state.assignData.adminToassignedAllLevels.splice(index, 1)
        }
    },
    SET_LEAD_CLASSIFICATION_DATA(state, data) {
        state.leadClassification = data;
    },
    SET_LEAD_CLASSIFICATION_RESTRICTION(state, data) {
        if (data.attribute == 'subAccountsCanNotChangeAssignLeads') {
            if (data.switchCheckBoxValue == 'on') {
                Vue.set(state.assignData, 'subAccountsCanNotChangeAssignLeads', 'Yes');
            } else {
                Vue.set(state.assignData, 'subAccountsCanNotChangeAssignLeads', 'No');
            }
        }
        if (data.attribute == 'subAccountsCanNotChangeLeadClassification') {
            if (data.switchCheckBoxValue == 'on') {
                Vue.set(state.leadClassification, 'subAccountsCanNotChangeLeadClassification', 'Yes');
            } else {
                Vue.set(state.leadClassification, 'subAccountsCanNotChangeLeadClassification', 'No');
            }
        }
    },
    CLEAR_LEAD_STATE(state) {
        state.assignData = [];
        state.leadClassification = [];
        state.addLeadData = [];
        state.completedData = []
        state.droppedData = []
        state.leadManagement = []
        state.leadSLA = [];
    },
    SET_ADD_LEAD_DATA(state, userData) {
        state.addLeadData = userData;
    },
    SET_COMPLETED_DATA(state, data) {
        state.completedData = data
    },
    SET_DROPPED_DATA(state, data) {
        state.droppedData = data
    },
    SET_LEAD_MANAGEMENT_DATA(state, data) {
        state.leadManagement = data
    },
    ADD_IMPORT_LEAD_DATA(state, data) {
        var newData = data;
        if (newData.length > 0) {
            for (var i = 0; i < newData.length; i++) {
                var index = state.leadManagement.allData.findIndex(e => e.LeadUsers.id == newData[i].id && e.LeadUsers.account_id == newData[i].account_id);
                if (index != -1) {
                    state.leadManagement.allData.splice(index, 1)
                }
                var data = {};
                data.LeadUsers = newData[i];
                state.leadManagement.allData.push(data)
            }
        }
    },
    CHANGE_LEAD_MANAGEMENT_DATA(state, data) {
        var newData = data;
        var index = state.leadManagement.allData.findIndex(lead => lead.LeadUsers.id == newData.pk && lead.LeadUsers.account_id == newData.name);
        state.leadManagement.allData[index].LeadUsers.status = newData.value;
    },
    SET_LEAD_SLA_DATA(state, data) {
        state.leadSLA = data
    },
    SET_LEAD_DASHBOARD_DATA(state, data) {
        state.dashBoardData = data;
    },
    RECENT_LEAD_ACTIVITIES_DATAS(state, data) {
        state.leadRecentData = data
    },

}

const actions = {
    fetchAssignLeadDatas({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/lead_management/assign_leads_list')
            .then(res => {
                Nprogress.done();
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    commit("SET_ASSIGN_DATA", res.data)
                }
            })
            .catch(error => console.log(error))
    },
    addAdminClassificationAd({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/assign_admin_to_other_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("ADD_LEAD_TO_OTHER_ADMIN", response.data.newData)
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    addUnassignedClassification({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/admin_view_unassigned_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("ADD_UNASSIGNED_LEAD_TO_OTHER_ADMIN", response.data.newData)
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    viewAllClassification({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/admin_view_assignedall_leads_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("ADD_ASSIGNED_ALL_LEAD_TO_OTHER_ADMIN", response.data.newData)
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    deleteAdminClassificationAd({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/delete_admin_to_other_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (response.data.status == 'success') {
                        commit("DELETE_LEAD_TO_OTHER_ADMIN", postData.adminClassificationId)
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    deleteAdminClassificationUnassigned({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/delete_admin_view_unassigned_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (response.data.status == 'success') {
                        commit("DELETE_UNASSIGNED_LEAD_TO_OTHER_ADMIN", postData.adminClassificationId)
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    viewAllClassificationDelete({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/delete_admin_view_assignedall_lead_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (response.data.status == 'success') {
                        commit("DELETE_ALL_ASSIGNED_LEAD_TO_OTHER_ADMIN", postData.adminClassificationId)
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    saveAllAssignedLeadData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/save_auto_assign_values', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    applyToAllSubZoneLeadAssign({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/add_assign_leads_to_subAcc', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    restrictAssignLead({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/settings/save_sub_accounts_cannot_change_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("SET_LEAD_CLASSIFICATION_RESTRICTION", postData);
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchLeadClassification({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/lead_management/lead_classification_list')
            .then(res => {
                Nprogress.done();
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    commit("SET_LEAD_CLASSIFICATION_DATA", JSON.parse(res.data))
                }
            })
            .catch(error => console.log(error))
    },
    deleteAdminClassification({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/del_adminclassifications_from_group', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    addAdminClassification({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/add_adminclassifications_to_group', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    saveEmailData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/edit_lead_field/Email', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    saveSmsData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/edit_lead_field/Sms', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    saveEnableData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/edit_lead_field/enable', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    saveHiddenField({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/save_lead_user_hide_field', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    savemappingField({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/save_lead_additional_map', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    applyToAllSubZoneLeadClassification({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/add_lead_classification_to_subAcc', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    restrictLeadClassification({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/settings/save_sub_accounts_cannot_change_settings', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("SET_LEAD_CLASSIFICATION_RESTRICTION", postData);
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchAddLeadData({
        commit,
    }, getData) {
        Nprogress.start()
        axios.get('/lead_management/add_lead/' + getData.leadId + '/' + getData.accountId + '/true')
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    commit('SET_ADD_LEAD_DATA', res.data.message);
                }
                var endArr = window.location.href.split('/');
                if (endArr.at(-1) != getData.accountId) {
                    window.location.href = '/lead_management/add_lead/' + getData.leadId + '/' + getData.accountId;
                }

            })
            .catch(error => console.log(error))
    },
    clearLeadState({
        commit,
        dispatch
    }) {
        commit('CLEAR_LEAD_STATE')
    },

    fetchCompletedLeadData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.post('/lead_management/get_all_completed_leads/', qs.stringify(authData, {
            parseArrays: false
        }))
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    commit('SET_COMPLETED_DATA', res.data)
                }
            })
            .catch(error => console.log(error))


    },
    fetchLeadHistory({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/get_task_admins', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchDroppedData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.post('/lead_management/get_all_dropped_leads/', qs.stringify(authData, {
            parseArrays: false
        }))
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    commit('SET_DROPPED_DATA', res.data)
                }
            })
            .catch(error => console.log(error))


    },
    activeDroppedLead({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/reapprove_lead', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    activeDroppedLeadAll({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/reapprove_lead_all', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    DeleteDroppedLeadAll({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/delete_all_leads', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchLeadManagementData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.post('/lead_management/get_all_leads/', qs.stringify(authData, {
            parseArrays: false
        }))
            .then(res => {
                Nprogress.done()
                console.log(res.data)
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    commit('SET_LEAD_MANAGEMENT_DATA', res.data)
                }
            })
            .catch(error => console.log(error))

    },
    saveLeadManagementStatus({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.post('/lead_management/change_lead_status', qs.stringify(authData, {
            parseArrays: false
        }))
            .then(res => {
                Nprogress.done()
                commit('CHANGE_LEAD_MANAGEMENT_DATA', authData)
            })
            .catch(error => console.log(error))
    },
    rejectLead({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/reject_lead', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    unclaimLead({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/unclaim_lead', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    claimLead({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/claim_lead', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    checkAssignAdmin({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/check_reassign_admin_permission', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    reassignAdmin({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/reassign_to_another_admin', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    importCopyPasteLeads({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/import_leaduser_file_copy', postData)
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (response.data.status == 'success') {
                        commit("ADD_IMPORT_LEAD_DATA", JSON.parse(response.data.leadData))
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    importcsvleads({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/import_leaduser_file', postData)
                .then(response => {
                    loader.hide()


                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (response.data.status == 'success') {
                        commit("ADD_IMPORT_LEAD_DATA", JSON.parse(response.data.leadData))
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    collectInventoryItems({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/collect_inventory_items', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    collectLeadInventoryItems({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/collect_return_inventory_submit', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    rejectAllLeadFromLead({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/reject_leads_all', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    splicingStage({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/splicing', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    submitCommissioning({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/cabling_and_commissioning', postData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    submitCafApproval({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/caf_approval', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    getPlanRate({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/users/getPlanRateBilling', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    initialPaymentSetting({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            // let loader = Vue.$loading.show({
            //     canCancel: false,
            // });
            axios.post('/lead_management/save_lead_inital_payment_settings', postData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(response => {
                    // loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    submitCAFCollection({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/caf_collection', postData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    sendLeadPaymentLink({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/send_lead_payment_link', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    submitLeadTransfer({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/transfer_lead', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    getCityNameInLeads({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/users/get_city_and_state', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    updateNewLead({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/approve_lead.json', postData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    rejectNewLead({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/reject_lead', postData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    addNewLead({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/create_lead', postData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    saveSingleFieldLead({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lead_management/save_single_field_lead', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('SET_ADD_LEAD_DATA', response.data.message);
                    resolve(response.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchLeadSLAData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/lead_management/lead_sla')
            .then(res => {
                Nprogress.done();
                commit("SET_LEAD_SLA_DATA", res.data)
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })
    },
    saveLeadSLAEmailSms({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/lead_management/lead_edit_field", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveAllDataLeadSla({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/lead_management/store_lead_sla_values", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addSubAccountLeadSla({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/lead_management/add_lead_sla_to_all_accounts", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchLeadDashboardDatas({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            Nprogress.start();
            axios.get('/lead_management/lead_dashboard')
                .then(res => {
                    console.log('res : ',res);
                    Nprogress.done();
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    } else {
                        commit("SET_LEAD_DASHBOARD_DATA", res.data)
                        resolve(res.data)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        console.log('res : ',error.response);
                        if (error.response.status == 403) {
                            window.location = "/dashboard";
                        }
                    }
                })
        })
    },
    getRecentLeadLogs({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            const vueData = true;
            axios
                .post("/lead_management/lead_event_logs/" + vueData, qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    loader.hide()
                    commit('RECENT_LEAD_ACTIVITIES_DATAS', response.data)

                })
                .catch(error => console.log(error));
        });
    },
    updateLeadUserDetails({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/lead_management/update_lead_user_data", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    mailDocuments({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("/users/mailDocuments", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}

const getters = {
    assignListGetters: state => {
        return state.assignData;
    },
    leadClassificationGetters: state => {
        return state.leadClassification;
    },
    addLeadGetter: state => {
        return state.addLeadData;
    },
    leadCompletedGetters: state => {
        return state.completedData;
    },
    leadDroppedGetters: state => {
        return state.droppedData;
    },
    leadManagementGetters: state => {
        return state.leadManagement;
    },
    leadSLAListGetters: state => {
        return state.leadSLA;
    },
    leadDashboardListGetters: state => {
        return state.dashBoardData;
    },
    leadRecentDataListGetters: state => {
        return state.leadRecentData;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}